export default `{
  "wait_for": "p"
}`